import React from 'react';
import PropTypes from 'prop-types';
import { TopActions, ButtonGroup, ActionButton } from './styles';

const ActionBar = ({
  onMoveToRental,
  onMoveToBridge,
  onMoveToPrimary,
  onMoveToBridgeRent,
  onMoveToNewConstruction,
  group,
  onNotMine,
  disabled,
}) => {
  const buttonConfigs = {
    bridge: [
      { label: 'Move to Bridge/Fix-Rent', onClick: onMoveToBridgeRent },
      { label: 'Move to New Construction', onClick: onMoveToNewConstruction },
      { label: 'Move to Rental', onClick: onMoveToRental },
      { label: 'Move to Primary', onClick: onMoveToPrimary },
      { label: 'Not Mine', onClick: onNotMine },
    ],
    'bridge-rent': [
      { label: 'Move to Bridge/Fix-Flip', onClick: onMoveToBridge },
      { label: 'Move to New Construction', onClick: onMoveToNewConstruction },
      { label: 'Move to Rental', onClick: onMoveToRental },
      { label: 'Move to Primary', onClick: onMoveToPrimary },
      { label: 'Not Mine', onClick: onNotMine },
    ],
    rental: [
      { label: 'Move to Bridge/Fix-Flip', onClick: onMoveToBridge },
      { label: 'Move to Bridge/Fix-Rent', onClick: onMoveToBridgeRent },
      { label: 'Move to New Construction', onClick: onMoveToNewConstruction },
      { label: 'Move to Primary', onClick: onMoveToPrimary },
      { label: 'Not Mine', onClick: onNotMine },
    ],
    primary: [
      { label: 'Move to Bridge/Fix-Flip', onClick: onMoveToBridge },
      { label: 'Move to Bridge/Fix-Rent', onClick: onMoveToBridgeRent },
      { label: 'Move to New Construction', onClick: onMoveToNewConstruction },
      { label: 'Move to Rental', onClick: onMoveToRental },
      { label: 'Not Mine', onClick: onNotMine },
    ],
    new_construction: [
      { label: 'Move to Bridge/Fix-Flip', onClick: onMoveToBridge },
      { label: 'Move to Bridge/Fix-Rent', onClick: onMoveToBridgeRent },
      { label: 'Move to Rental', onClick: onMoveToRental },
      { label: 'Move to Primary', onClick: onMoveToPrimary },
      { label: 'Not Mine', onClick: onNotMine },
    ],
  };

  const currentButtons = buttonConfigs[group] || [];

  return (
    <TopActions>
      <ButtonGroup>
        {currentButtons.map((button) => (
          <ActionButton
            key={button.label}
            type="button"
            onClick={button.onClick}
            disabled={disabled}
          >
            {button.label}
          </ActionButton>
        ))}
      </ButtonGroup>
    </TopActions>
  );
};

ActionBar.propTypes = {
  onMoveToRental: PropTypes.func.isRequired,
  onMoveToBridge: PropTypes.func.isRequired,
  onMoveToPrimary: PropTypes.func.isRequired,
  onMoveToBridgeRent: PropTypes.func.isRequired,
  onNotMine: PropTypes.func.isRequired,
  group: PropTypes.oneOf(['bridge', 'bridge-rent', 'new_construction', 'rental', 'primary']).isRequired,
  disabled: PropTypes.bool,
};

ActionBar.defaultProps = {
  disabled: false,
};

export default ActionBar;
